// extracted by mini-css-extract-plugin
var _1 = "TitleBar__main--_Rq67";
var _2 = "TitleBar__title--MEGGF CoreGeneral__robotoSlab--X8lgW fontSize__chapterBar--idh3m";
var _3 = "TitleBar__titleShiftedUp--xthFg TitleBar__title--MEGGF CoreGeneral__robotoSlab--X8lgW fontSize__chapterBar--idh3m";
var _4 = "TitleBar__titleSimplified--mZ2sd TitleBar__title--MEGGF CoreGeneral__robotoSlab--X8lgW fontSize__chapterBar--idh3m";
var _5 = "TitleBar__tray--GPWhO";
export { _1 as "main", _2 as "title", _3 as "titleShiftedUp", _4 as "titleSimplified", _5 as "tray" }
